import routerOptions0 from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}